import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import checkedCircle from "@/assets/check-circle.png";
import {
  OTP_PREFERENCE_EMAIL,
  OTP_PREFERENCE_TOTP,
  type OtpPreference,
} from "../../domain/constants/otpConstants";
import AuthPageShell from "../components/AuthPageShell";

const SuccessfulTwoFASetup = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = React.useState(5);

  const otpPreference: OtpPreference =
    (location.state as { otpPreference?: OtpPreference } | null)?.otpPreference ??
    OTP_PREFERENCE_TOTP;

  const message =
    otpPreference === OTP_PREFERENCE_EMAIL
      ? t("success.twoFaSetup.messageEmail")
      : t("success.twoFaSetup.messageTotp");

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => Math.max(prev - 1, 0));
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/patients");
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <AuthPageShell title={t("success.twoFaSetup.title")}>
      <div className="flex flex-col items-center gap-4 text-center">
        <img src={checkedCircle} alt="success" className="h-12 w-12" />
        <p className="text-sm text-gray-500">{message}</p>
        <div className="mt-4 text-sm text-gray-600">
          {t("success.twoFaSetup.redirecting")}{" "}
          <span className="font-semibold text-gray-900">
            {t("success.twoFaSetup.dashboard")}
          </span>{" "}
          {t("success.twoFaSetup.inSeconds", { count: countdown })}
        </div>
      </div>
    </AuthPageShell>
  );
};

export default SuccessfulTwoFASetup;
